import viewItem from '../../src/components/item/pages/view';

export default [
    {
        path:':id/:title',
        component: viewItem
    }
]